import { render, staticRenderFns } from "./visit-waiting-collect-case-manage.vue?vue&type=template&id=06c86642&scoped=true"
import script from "./visit-waiting-collect-case-manage.vue?vue&type=script&lang=ts"
export * from "./visit-waiting-collect-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c86642",
  null
  
)

export default component.exports